__turbopack_context__.v({
  "buttonBigCall": "ButtonBigCall-module-scss-module__Yz_1Ea__buttonBigCall",
  "buttonBigCallImg": "ButtonBigCall-module-scss-module__Yz_1Ea__buttonBigCallImg",
  "buttonBigCallText": "ButtonBigCall-module-scss-module__Yz_1Ea__buttonBigCallText",
});
